"use strict";
export const recipientColumns = [
  {
    id: "id",
    label: "ID",
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: "name",
    label: "Name",
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: "emails",
    label: "Emails",
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: "status",
    label: "Status",
    sortable: true,
    canToggle: false,
    enabled: true
  }
];
